import { 
  faBell,
  faBiohazard,
  faBoltLightning,
  faBomb,
  faBoxOpen,
  faBuilding,
  faCar,
  faChildReaching,
  faCircleExclamation,
  faClouds,
  faDoorOpen,
  faExplosion,
  faFire,
  faGun,
  faHeat,
  faHurricane, 
  faLock,
  faMessage,
  faPersonFalling,
  faPersonMilitaryRifle,
  faPersonShelter,
  faRadiation,
  faRaindrops,
  faShield,
  faShieldCheck,
  faSkullCrossbones,
  faSnowflake,
  faSuitcaseMedical,
  faTemperatureHalf,
  faTornado,
  faTriangleExclamation, 
  faUnlock,
  faUserDoctor,
  faUserPolice,
  faUsers,
  faUserShield,
  faVirus,
  faVolcano, 
  faWater,
  faWifiSlash,
  faWindsock
} from '@fortawesome/pro-regular-svg-icons'


export const getIconData = () => {
  return [
    {
      'name': 'Alert', 
      'code': 'triangle-exclamation',
      'icon': faTriangleExclamation
    },
    {
      'name': 'Bell', 
      'code': 'bell',
      'icon': faBell
    },
    {
      'name': 'Biohazard', 
      'code': 'biohazard',
      'icon': faBiohazard
    },
    {
      'name': 'Bomb', 
      'code': 'bomb',
      'icon': faBomb
    },
    {
      'name': 'Box', 
      'code': 'box-open',
      'icon': faBoxOpen
    },
    {
      'name': 'Building', 
      'code': 'building',
      'icon': faBuilding
    },
    {
      'name': 'Car', 
      'code': 'car',
      'icon': faCar
    }, 
    {
      'name': 'Child', 
      'code': 'child-reaching',
      'icon': faChildReaching
    },
    {
      'name': 'Clouds', 
      'code': 'clouds',
      'icon': faClouds
    }, 
    {
      'name': 'Doctor', 
      'code': 'user-doctor',
      'icon': faUserDoctor
    },
    {
      'name': 'Exclamation', 
      'code': 'circle-exclamation',
      'icon': faCircleExclamation
    }, 
    {
      'name': 'Explosion', 
      'code': 'explosion',
      'icon': faExplosion
    },
    {
      'name': 'Fire', 
      'code': 'fire',
      'icon': faFire
    },
    {
      'name': 'Heat', 
      'code': 'heat',
      'icon': faHeat
    },
    {
      'name': 'Hurricane', 
      'code': 'hurricane',
      'icon': faHurricane
    },
    {
      'name': 'Lightning', 
      'code': 'bolt-lightning',
      'icon': faBoltLightning
    },
    {
      'name': 'Lock', 
      'code': 'lock',
      'icon': faLock
    }, 
    {
      'name': 'Medical', 
      'code': 'suitcase-medical',
      'icon': faSuitcaseMedical
    },
    {
      'name': 'Message', 
      'code': 'message',
      'icon': faMessage
    }, 
    {
      'name': 'Network', 
      'code': 'wifi-slash',
      'icon': faWifiSlash
    },
    {
      'name': 'Military', 
      'code': 'person-military-rifle',
      'icon': faPersonMilitaryRifle
    }, 
    {
      'name': 'Open Door', 
      'code': 'door-open',
      'icon': faDoorOpen
    },
    {
      'name': 'Person Burst', 
      'code': 'person-falling-burst',
      'icon': faPersonFalling
    }, 
    {
      'name': 'Police', 
      'code': 'user-police',
      'icon': faUserPolice
    }, 
    {
      'name': 'Poison', 
      'code': 'skull-crossbones',
      'icon': faSkullCrossbones
    },
    {
      'name': 'Radiation', 
      'code': 'radiation',
      'icon': faRadiation
    }, 
    {
      'name': 'Rain', 
      'code': 'raindrops',
      'icon': faRaindrops
    },    
    {
      'name': 'Security', 
      'code': 'user-shield',
      'icon': faUserShield
    },
    {
      'name': 'Shelter', 
      'code': 'person-shelter',
      'icon': faPersonShelter
    },
    {
      'name': 'Shield', 
      'code': 'shield',
      'icon': faShield
    }, 
    {
      'name': 'Shield Check', 
      'code': 'shield-check',
      'icon': faShieldCheck
    },
    {
      'name': 'Snow', 
      'code': 'snowflake',
      'icon': faSnowflake
    }, 
    {
      'name': 'Suspicious Person', 
      'code': 'user-secret',
      'icon': faUsers
    },   
    {
      'name': 'Temperature', 
      'code': 'temperature-half',
      'icon': faTemperatureHalf
    }, 
    {
      'name': 'Tornado', 
      'code': 'tornado',
      'icon': faTornado
    }, 
    {
      'name': 'Unlock', 
      'code': 'unlock',
      'icon': faUnlock
    },  
    {
      'name': 'Virus', 
      'code': 'virus',
      'icon': faVirus
    },  
    {
      'name': 'Volcano', 
      'code': 'volcano',
      'icon': faVolcano
    },  
    {
      'name': 'Water', 
      'code': 'water',
      'icon': faWater
    },  
    {
      'name': 'Weapon', 
      'code': 'gun',
      'icon': faGun
    },  
    {
      'name': 'Wind', 
      'code': 'windsock',
      'icon': faWindsock
    } 
  ] ;
};
